import React from 'react';
import styled from 'styled-components';

import ListItem from 'components/atoms/list-item';

const ListDiv = styled.div`
  > div {
    border: solid 1px #d2d2d2;
    border-top: 0px;
  }
  > div:first-child {
    border: solid 1px #d2d2d2;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  > div:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  > div:hover {
    @media only screen and (min-width: 600px) {
      border-color: #6e0ad6;
    }
  }
`;

type Props = {
  itens: any[];
  clickHandler: Function;
};

const ListContainer = (props: Props) => {
  const { itens, clickHandler } = props;

  const listItens = itens.map((item) => {
    return (
      /* @ts-ignore */
      <ListItem
        id={`${item.name}-${item.id}`}
        key={`${item.type}-${item.id}`}
        clickHandler={clickHandler}
        item={item}
      />
    );
  });

  return (
    <div>
      <ListDiv>{listItens}</ListDiv>
    </div>
  );
};

export default ListContainer;
